var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRealTimeActivity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.007,
    height: 65.007,
    viewBox: "0 0 65.007 65.007",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "task_11456778",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M32.613,32.922H34.1a15.031,15.031,0,0,0-3.591-8.648L29.463,25.33a1.182,1.182,0,0,1-1.65,0,1.169,1.169,0,0,1,0-1.648l1.058-1.045a15.066,15.066,0,0,0-8.658-3.587v1.486a1.162,1.162,0,0,1-2.324,0V19.05A15.066,15.066,0,0,0,9.23,22.637l1.058,1.045a1.167,1.167,0,0,1-1.65,1.648L7.591,24.274A15.031,15.031,0,0,0,4,32.922H5.488a1.161,1.161,0,1,1,0,2.322H4a15.032,15.032,0,0,0,3.591,8.648l1.046-1.056a1.166,1.166,0,1,1,1.65,1.648L9.23,45.529a15.067,15.067,0,0,0,8.658,3.587V47.63a1.162,1.162,0,0,1,2.324,0v1.486a15.067,15.067,0,0,0,8.658-3.587l-1.058-1.045a1.166,1.166,0,0,1,1.65-1.648l1.046,1.056A15.032,15.032,0,0,0,34.1,35.244H32.613a1.161,1.161,0,0,1,0-2.322Zm-8.135,2.322H19.05a1.165,1.165,0,0,1-1.162-1.161V27.315a1.162,1.162,0,0,1,2.324,0v5.607h4.265a1.161,1.161,0,0,1,0,2.322Z",
    transform: "translate(0 2.421)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M38.787,50c-7.68.239-7.679,11.37,0,11.608C46.468,61.369,46.466,50.238,38.787,50Z",
    transform: "translate(4.669 7.399)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M38.787,4c-7.68.239-7.679,11.37,0,11.608C46.468,15.369,46.466,4.238,38.787,4Z",
    transform: "translate(4.669 0)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M38.787,27c-7.68.239-7.679,11.37,0,11.608C46.468,38.369,46.466,27.238,38.787,27Z",
    transform: "translate(4.669 3.699)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M39.312,26.553V15.92a7.114,7.114,0,0,1-2.324,0V26.553a7.117,7.117,0,0,1,2.324,0Z",
    transform: "translate(5.306 1.917)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M39.312,49.553V38.92a7.114,7.114,0,0,1-2.324,0V49.553A7.117,7.117,0,0,1,39.312,49.553Z",
    transform: "translate(5.306 5.616)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M47.158,7.822H61.1a1.161,1.161,0,0,0,0-2.322H47.158A1.161,1.161,0,0,0,47.158,7.822Z",
    transform: "translate(6.757 0.241)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M61.1,10.5H47.158a1.161,1.161,0,0,0,0,2.322H61.1A1.161,1.161,0,0,0,61.1,10.5Z",
    transform: "translate(6.757 1.045)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M61.1,28.5H47.158a1.161,1.161,0,0,0,0,2.322H61.1A1.161,1.161,0,0,0,61.1,28.5Z",
    transform: "translate(6.757 3.941)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M61.1,33.5H47.158a1.161,1.161,0,0,0,0,2.322H61.1A1.161,1.161,0,0,0,61.1,33.5Z",
    transform: "translate(6.757 4.745)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M61.1,51.5H47.158a1.161,1.161,0,0,0,0,2.322H61.1A1.161,1.161,0,0,0,61.1,51.5Z",
    transform: "translate(6.757 7.64)",
    fill: "#7b7bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M61.1,56.5H47.158a1.161,1.161,0,0,0,0,2.322H61.1A1.161,1.161,0,0,0,61.1,56.5Z",
    transform: "translate(6.757 8.444)",
    fill: "#7b7bff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimeActivity);
export default __webpack_public_path__ + "static/media/real-time-activity.b85a5f21cf1c0403104e7f6ab91351a6.svg";
export { ForwardRef as ReactComponent };